import React, { useEffect, useState } from "react";

const Header = () => {
    const titles = [
        "Software Developer",
        "Distributed Systems Enthusiast",
        "Full Stack Engineer",
        "Cloud Solutions Architect",
        "Open Source Contributor"
    ];

    const [currentTitleIndex, setCurrentTitleIndex] = useState(0);
    const [titleState, setTitleState] = useState("visible");
    const [displayedTitle, setDisplayedTitle] = useState(titles[0]);

    // Ensure the header takes full viewport height on load
    useEffect(() => {
        const adjustHeight = () => {
            const header = document.getElementById('fh5co-header');
            if (header) {
                header.style.height = `${window.innerHeight}px`;
            }
        };

        // Set initially and add resize listener
        adjustHeight();
        window.addEventListener('resize', adjustHeight);

        // Cleanup
        return () => {
            window.removeEventListener('resize', adjustHeight);
        };
    }, []);

    // Effect for title rotation
    useEffect(() => {
        const titleInterval = setInterval(() => {
            // Start exit animation
            setTitleState("exiting");

            // After exit animation completes, change the title and start entry animation
            setTimeout(() => {
                const nextIndex = (currentTitleIndex + 1) % titles.length;
                setCurrentTitleIndex(nextIndex);
                setDisplayedTitle(titles[nextIndex]);
                setTitleState("entering");

                // After a short delay, make the new title fully visible
                setTimeout(() => {
                    setTitleState("visible");
                }, 50);
            }, 800); // Match this to the transition duration in CSS

        }, 1800); // Show each title for 2 seconds

        return () => clearInterval(titleInterval);
    }, [currentTitleIndex, titles]);

    return (
        <header
            id="fh5co-header"
            className="fh5co-cover"
            role="banner"
            style={{
                backgroundImage: `url(${process.env.PUBLIC_URL}/images/cover_bg_3.jpg)`,
                height: '100vh', // 100% of viewport height
                backgroundSize: 'cover',
                backgroundPosition: 'center center',
                position: 'relative',
                backgroundAttachment: 'fixed'
            }}
            data-stellar-background-ratio="0.5"
        >
            <div className="overlay" style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0, 0, 0, 0.5)' }}></div>
            <div className="container" style={{ height: '100%', display: 'flex', alignItems: 'center' }}>
                <div className="row" style={{ width: '100%' }}>
                    <div className="col-md-8 col-md-offset-2 text-center">
                        <div className="display-t" style={{ height: '100%', display: 'table' }}>
                            <div className="display-tc animate-box" data-animate-effect="fadeIn" style={{ display: 'table-cell', verticalAlign: 'middle' }}>
                                <div className="profile-thumb" style={{
                                    background: `url(${process.env.PUBLIC_URL}/images/user-3.jpg)`,
                                    width: '160px',
                                    height: '160px',
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                    borderRadius: '50%',
                                    margin: '0 auto',
                                    marginBottom: '25px',
                                    border: '4px solid rgba(255, 255, 255, 0.2)'
                                }}></div>
                                <h1><span>Ashu Kumar</span></h1>

                                <div className="title-switcher">
                                    <h3 className={`title-text ${titleState}`}>
                                        {displayedTitle}
                                    </h3>
                                </div>

                                <div className="social-links" style={{ marginTop: '30px' }}>
                                    <ul className="fh5co-social-icons">
                                        <li><a href="https://linkedin.com/in/catchashu10"><i className="icon-linkedin2"></i></a></li>
                                        <li><a href="https://github.com/catchashu10"><i className="icon-github"></i></a></li>
                                    </ul>
                                </div>
                                <div style={{ marginTop: '45px', position: 'absolute', bottom: '30px', left: '0', right: '0' }}>
                                    <a href="#fh5co-about" style={{
                                        display: 'inline-block',
                                        color: 'white',
                                        fontSize: '24px',
                                        animation: 'bounce 2s infinite'
                                    }}>
                                        <i className="icon-chevron-down"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header; 